import { useTracking } from '@change-corgi/core-react/tracking';

import {
	useLocalPageData,
	useLocalPagePaginatedVictoriousPetitionsData,
} from '#src/app/pages/local/details/pageContext';
import type { LocalVictoriousPetitionsItem } from '#src/app/pages/local/details/pageContext';

type Result = ModelHookResult<
	{
		displayed: boolean;
		displayName: string;
		petitions: readonly LocalVictoriousPetitionsItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function useVictoriousPetitionsSection(): Result {
	const {
		data: { displayName },
	} = useLocalPageData();
	const track = useTracking();

	const {
		data: { hasNextPage, items, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useLocalPagePaginatedVictoriousPetitionsData();

	return {
		data: {
			petitions: items,
			displayed: totalCount > 0,
			displayName,
			hasNextPage,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('local_page_load_more_victorious_petitions_click');
				loadMore();
			},
		},
	};
}
